import { Action, ACTIONS } from './types'

export const toggleLayout: () => Action = () => ({
    type: ACTIONS.toggleMobileMenu,
})
